import {Component, OnInit} from '@angular/core';
import {AppConfig} from "./app.config";
import {HttpService} from "./services/http.service";
import {Ng2LoadingBarService} from "./services/loading-bar-service";
import {Meta, Title} from "@angular/platform-browser";
import {ActivatedRoute, NavigationEnd, Router, RoutesRecognized} from "@angular/router";


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
})

export class AppComponent {

    constructor(private router: Router,
                private titleService: Title,
                public http: HttpService,
                private loadingBar: Ng2LoadingBarService,
                private meta: Meta) {
        AppConfig.instance = new AppConfig(http);

        router.events.subscribe((val) => {
            if (val instanceof NavigationEnd) {
                this.loadingBar.start();
                AppConfig.instance.getMetaAllPages(metaTitle => {
                    let temp: any = this.router.url.split('/');
                    temp = temp[1].split('?');

                    let key = temp[0];

                    if (key === '') {
                        key = 'home';
                    }

                    const pageKey = metaTitle[key];
                    this.meta.updateTag({name: 'description', content: pageKey.description});
                    this.meta.updateTag({name: 'keywords', content: pageKey.keywords});
                    this.setTitle(pageKey.title);
                    this.loadingBar.complete();
                });
                if (!(val instanceof NavigationEnd)) {
                    return;
                }
                window.scrollTo(0, 0);
            }


        },  error => {
            console.log(error);
        });
    }

    public setTitle(newTitle: string) {
        this.titleService.setTitle(newTitle);
    }
}


// WEBPACK FOOTER //
// /home3/usalinks/public_html/ally-book-source/src/app/app.component.ts